import { NodeProps, Node, Handle, Position } from "@xyflow/react";
import { TABLE_ICONS } from "types/Icons";
import { WorkflowDiagramReactFlowProps } from "../WorkflowDiagramReactFlow";
import { workflowDiagramStyles } from "../workflowDiagramStyles";
import { NodeIcon } from "./NodeIcon";
import { nodeStyles } from "./nodeStyles";

export const ResultNode = ({
  data,
  sourcePosition,
  targetPosition,
}: NodeProps<
  Node<WorkflowDiagramReactFlowProps["graphResults"][number]["data"]>
>) => {
  const discarded = data.outputPolicy === "DISCARD";
  return (
    <div
      style={{
        ...nodeStyles.base,
        ...(discarded
          ? workflowDiagramStyles.shapes.discard
          : workflowDiagramStyles.shapes.keep),
      }}
      title={data.label}
    >
      <NodeIcon type={TABLE_ICONS.output} label="Output" />

      <div
        style={{
          ...nodeStyles.name,
          textDecoration: discarded ? "line-through" : "none",
        }}
      >
        {data.label}
      </div>
      <Handle type="target" position={targetPosition ?? Position.Top} />
      <Handle
        type="source"
        position={sourcePosition ?? Position.Bottom}
        style={nodeStyles.unusedHandle}
      />
    </div>
  );
};
